
function initHeaderRating() {
  document.addEventListener("DOMContentLoaded", function () {
    let lastScrollTop = 0;
    const navbarTop = document.getElementById("stamped-reviews-widget");
    if(!navbarTop){
      return
    }
    window.addEventListener("scroll", function() {
        // console.log("scroll");
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop > lastScrollTop) {
            // 向下滚动
            console.log("向下滚动");
            // navbarTop.style. = "none"; // 隐藏上半部分（根据实际高度调整）
          navbarTop.style.opacity = '0';
        } else {
            // 向上滚动
            console.log("向上滚动");
            // navbarTop.style.display = "flex"; // 显示上半部分
          navbarTop.style.opacity = '1';
        }
        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
    });
  })
}
initHeaderRating();